import { default as Mui5FormControlLabel } from '@mui/material/FormControlLabel'

export const FormControlLabel = Mui5FormControlLabel
